import styles from "./styles.module.css";
import * as Editors from "../../../editors";
export default function ({ config, schema = [], onChange }) {
  const handleChange = (key, value) => {
    const _config = { ...config };
    _config[key] = value;
    onChange(_config);
  };
  return (
    <div className={styles.paper}>
      {schema.map((prop) => {
        return (
          <PropInput
            key={prop.name}
            prop={prop}
            value={config[prop.name]}
            onChange={(v) => handleChange(prop.name, v)}
          />
        );
      })}
    </div>
  );
}

const PropInput = ({ value, onChange, prop }) => {
  const Input = Editors[prop.editor];

  return (
    <div className={styles.propInput}>
      <div className={styles.propTitle}>{prop.displayName}</div>
      <Input value={value} onChange={onChange} />
      <div className={styles.propHelp}>{prop.help}</div>
    </div>
  );
};
